import React from 'react';
import * as _ from 'lodash';
import Action, { IActionParentProps } from '../../Action';
import useStreamingSession from '../../../hooks/useSession';
import { OggFieldService } from '../../../services/ogg.service';
import { IProposedWorkItem } from '../../../types';
import { useSettings } from '../../../hooks/useSettings';
import { ProposedWorkItemList } from './ProposedWorkItemList';
import { StreamingSession } from '../../../services/streamingSession.service';
import { ScribePresentation } from './ScribePresentation';

interface IScribeContentProps {
  streamingContent: string;
  oggService: OggFieldService;
  streamingSession: StreamingSession;
}

interface IProposedWorkItems {
  workItems: IProposedWorkItem[];
}

function ScribeContent(props: IScribeContentProps) {
  const settings = useSettings();

  function toExtractedWorkItems(message: string): IProposedWorkItems {
    return JSON.parse(message);
  }

  function trySuffixes(suffixes: string[]) {
    for (let suffix of suffixes) {
      try {
        return toExtractedWorkItems(props.streamingContent + suffix);
      } catch (error) {}
    }

    console.warn(
      "Couldn't create a work item array after applying suffixes. Here's the input: ",
      `'${props.streamingContent}'`
    );
    return { workItems: [] };
  }

  let proposal: IProposedWorkItems = trySuffixes(['', '"}]}', '""}]}', '\\""}]}']);

  // Default the work item's status to "Proposed"
  for (var wi of proposal.workItems ?? []) wi.status ??= 'Proposed';

  console.debug('loading work items', proposal);

  return (
    <ProposedWorkItemList
      extractedWorkItems={proposal.workItems ?? []}
      onWorkItemCreated={(workItem) => {
        const workItemPosition = proposal.workItems.findIndex((x) => x.title == workItem.title);
        proposal.workItems[workItemPosition] = workItem;
        props.streamingSession.setCachedMessage(
          JSON.stringify(proposal),
          settings.useSessionStorage
        );
      }}
    />
  );
}

export function Scribe({ streamingSession, oggService }: IActionParentProps) {
  console.debug('loading scribe');
  const [streamingContent] = useStreamingSession(streamingSession);

  return (
    <Action
      presentation={{
        name: 'The Scribe',
        description: (
          <p>
            I'll generate User Stories and Features from your transcription with the Stakeholder and
            use this work item as the parent.
          </p>
        ),
        imageName: 'TheScribe.png',
        onStart: () => oggService.callScribeStream(streamingSession),
        customRender: ScribePresentation,
      }}
      streamOutput={{
        loadingTitle: 'Ogg is enriching the work item...',
        loadingSubtitle: 'Fetching the suggestions from the server',
        render: (message) =>
          ScribeContent({
            streamingContent: message,
            oggService: oggService,
            streamingSession,
          }),
        streamingContent,
        streamingSession,
      }}
    ></Action>
  );
}
